export default __webpack_public_path__ + "static/media/EM0190.34I-19950_-23282_0.6ffe08a2.jpg";